import { render, staticRenderFns } from "./Geschaeftspartner.vue?vue&type=template&id=2400f45e&"
import script from "./Geschaeftspartner.vue?vue&type=script&lang=js&"
export * from "./Geschaeftspartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports